import Logger from '../util/Logger';
import _ from 'lodash';

const getPostsSentimentPositive = (segment) => {
  if (!segment) {
    Logger.assert('Missing segment');
  } else {
    return _.get(segment, 'posts_sentiment_positive') || 0;
  }
};

const getPostsSentimentNegative = (segment) => {
  if (!segment) {
    Logger.assert('Missing segment');
  } else {
    return _.get(segment, 'posts_sentiment_negative') || 0;
  }
};

const getPostsSentimentNeutral = (segment) => {
  if (!segment) {
    Logger.assert('Missing segment');
  } else {
    return _.get(segment, 'posts_sentiment_neutral') || 0;
  }
};

const getTotal = (segment) => {
  if (!segment) {
    Logger.assert('Missing segment');
  } else {
    return (
      getPostsSentimentNegative(segment) +
      getPostsSentimentNeutral(segment) +
      getPostsSentimentPositive(segment)
    );
  }
};

export default {

  getName (segment) {
    if (!segment) {
      Logger.assert('Missing segment');
    } else {
      return _.get(segment, 'name');
    }
  },

  isInsufficientActivity (segment) {
    if (!segment) {
      Logger.assert('Missing segment');
    } else {
      return _.get(segment, 'insufficient_activity');
    }
  },

  getSimpleScore (segment) {
    if (!segment) {
      Logger.assert('Missing segment');
    } else {
      return _.get(segment, 'simple_score') || null;
    }
  },

  getSimpleScoreDisplay (segment) {
    if (!segment) {
      Logger.assert('Missing segment');
    } else {
      return _.get(segment, 'simple_score_display') || null;
    }
  },

  getSentimentPositivePercent (segment) {
    if (!segment) {
      Logger.assert('Missing segment');
    } else {
      const total = getTotal(segment);
      return total ? (getPostsSentimentPositive(segment) / total) * 100 : 0;
    }
  },

  getSentimentNegativePercent (segment) {
    if (!segment) {
      Logger.assert('Missing segment');
    } else {
      const total = getTotal(segment);
      return total ? (getPostsSentimentNegative(segment) / total) * 100 : 0;
    }
  },

  getSentimentNeutralPercent (segment) {
    if (!segment) {
      Logger.assert('Missing segment');
    } else {
      const total = getTotal(segment);
      return total ? (getPostsSentimentNeutral(segment) / total) * 100 : 0;
    }
  }

};
